<template>
  <main>
    <div v-if="currentUser !== null && currentFluxer[0]" class="Objetivos">
      <headerFeed :currentUser="currentUser" title="Acuerdo de Objetivos"></headerFeed>
      <md-progress v-if="loading" class="md-accent" md-indeterminate></md-progress>
      <md-layout md-gutter class="contenidoPagina">
        <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-align="center">
          <main>
            <h3 class="md-title">En borrador</h3>
            <md-spinner v-show="loader" md-indeterminate></md-spinner>
            <p v-if="acuerdosPendientes.length === 0 && !loader">No tienes un acuerdos de objetivos en borrador aún.</p>
            <div v-for="acuerdo in acuerdosPendientes">
              <acuerdo @click.native="openSetDetail(acuerdo)" :key="acuerdo['.key']" :acuerdo="acuerdo" :fluxer="acuerdo.owner"></acuerdo>
              <br>
            </div>
          </main>
        </md-layout>

        <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-align="center">
          <main>
            <h3 class="md-title">Enviados</h3>
            <md-spinner v-show="loader" md-indeterminate></md-spinner>
            <p v-if="acuerdosEnviados.length === 0 && !loader">No tienes un acuerdos de objetivos archivados aún.</p>
            <div v-for="acuerdo in acuerdosEnviados">
              <acuerdo @click.native="openDetail(acuerdo)" :key="acuerdo['.key']" :acuerdo="acuerdo" :fluxer="acuerdo.owner"></acuerdo>
              <br>
            </div>
          </main>
        </md-layout>

      </md-layout>

      <md-dialog md-open-from="#custom" md-close-to="#custom" ref="dialog-objetivos">
        <md-dialog-title>Seleccione fluxer</md-dialog-title>
        <md-dialog-content>
          <autocomplete v-model="fluxerSelected" :label="'Busca al fluxer aqui'" :array="allFluxers" :debounce="1000"></autocomplete>
          <span v-show="error" class="md-error">El fluxer seleccionado es incorrecto</span>
        </md-dialog-content>

        <md-dialog-actions>
            <md-button class="md-primary" @click="closeDialog('dialog-objetivos')">Cancel</md-button>
            <md-button class="md-primary" @click="confirmDialog('dialog-objetivos')">Ok</md-button>
        </md-dialog-actions>
      </md-dialog>

      <md-dialog md-open-from="#custom" md-close-to="#custom" ref="advertencia">
        <md-dialog-content>El fluxer ya tiene un acuerdo de objetivos vigente, debe finalizarlo para poder crear otro</md-dialog-content>

        <md-dialog-actions>
          <md-button class="md-primary" @click="verVigente('advertencia')">Ver acuerdo vigente</md-button>
          <md-button class="md-primary" @click="closeDialog('advertencia')">Ok</md-button>
        </md-dialog-actions>
      </md-dialog>

      <router-view></router-view>
    </div>
  </main>
</template>

<script>

import header from './Header'
import SetObjetivos from './SetObjetivos'
import FluxerService from '../services/fluxer'
import ObjetivosService from '../services/objetivos'
import Autocomplete from './Autocomplete'
import Acuerdo from './Acuerdo'
import Router from '../router'

import _ from 'lodash'

export default {
  name: 'acuerdo-de-objetivos',
  components: {
    'headerFeed': header,
    'set-objetivos': SetObjetivos,
    'autocomplete': Autocomplete,
    'acuerdo': Acuerdo
  },
  data () {
    return {
      currentUser: FluxerService.getCurrentUser(),
      fluxerSelected: '',
      fluxerObjectSelect: null,
      acuerdoVigente: null,
      loading: false,
      loader: true,
      error: false
    }
  },
  firebase: function () {
    return {
      currentFluxer: FluxerService.getFluxerByEmail(this.currentUser.email),
      allFluxers: FluxerService.getAll(),
      acuerdos: {
        source: ObjetivosService.getByEmailEditor(this.currentUser.email),
        readyCallback: function () {
          this.loader = false
        }
      }
    }
  },
  computed: {
    acuerdosPendientes: function () {
      return _.filter(this.acuerdos, function (o) { return !o.sent })
    },
    acuerdosEnviados: function () {
      return _.filter(this.acuerdos, function (o) { return o.sent })
    }
  },
  methods: {
    openSelectFluxer (ref) {
      this.$refs[ref].open()
    },
    confirmDialog (ref) {
      let fluxerSelected = this.fluxerSelected
      this.fluxerObjectSelect = _.find(this.allFluxers, function (o) { return o.displayName === fluxerSelected })
      if (this.fluxerObjectSelect) {
        let fluxerObjectSelect = this.fluxerObjectSelect
        this.closeDialog(ref)
        this.loading = true
        ObjetivosService.createAcuerdo(this.currentUser.email, this.fluxerObjectSelect.email).then((resp) => {
          if (!resp.data.hayVigente) {
            Router.push({name: 'set-acuerdo', params: {id: resp.data.acuerdoId, fluxerSelected: fluxerObjectSelect}})
          } else {
            this.acuerdoVigente = _.find(this.acuerdos, function (o) { return o['.key'] === resp.data.acuerdoId })
            this.$refs.advertencia.open()
          }
          this.loading = false
        })
      } else {
        this.error = true
      }
    },
    verVigente (ref) {
      this.openDetail(this.acuerdoVigente)
      this.closeDialog(ref)
    },
    closeDialog (ref) {
      this.fluxerSelected = ''
      this.$refs[ref].close()
    },
    openSetDetail (acuerdo) {
      let fluxerObjectSelect = _.find(this.allFluxers, function (o) { return o.email === acuerdo.owner })
      Router.push({name: 'set-acuerdo', params: {id: acuerdo['.key'], fluxerSelected: fluxerObjectSelect}})
    },
    openDetail (acuerdo) {
      let fluxerObjectSelect = _.find(this.allFluxers, function (o) { return o.email === acuerdo.owner })
      Router.push({name: 'acuerdo-detail', params: {id: acuerdo['.key'], fluxerSelected: fluxerObjectSelect}})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .set-objetivos {
        position: fixed !important;
        right: 10px;
        bottom: 10px;
        width: 56px !important;
        height: 56px !important;
        z-index: 10;
    }

  .contenidoPagina {
    padding-top: 64px;
  }
</style>



// WEBPACK FOOTER //
// AcuerdoDeObjetivos.vue?30bdc944